// extracted by mini-css-extract-plugin
export var arrows = "_45-6";
export var decrementer = "_45-a";
export var disabled = "_45-4";
export var error = "_45-1";
export var hiddenText = "_45-b";
export var incrementer = "_45-9";
export var input = "_45-8";
export var inputWrapper = "_45-0";
export var leadingIcon = "_45-c";
export var readonly = "_45-3";
export var regular = "_45-7";
export var small = "_45-5";
export var warning = "_45-2";